///ts:ref=pixi.js
/// No file or directory matched name "pixi.js" ///ts:ref:generated

(Object as any).assign(PIXI.WebGLRenderer.prototype, {
	bindTexture: function(texture: PIXI.BaseTexture, location: number, forceLocation: boolean)
	{
		texture = texture || this.emptyTextures[location];
		texture = (texture as any).baseTexture || texture;
		(texture as any).touched = this.textureGC.count;

		const gl = this.gl;
		const glTexture = (texture as any)._glTextures[this.CONTEXT_UID];
		const _updateID = texture.source && (texture.source as any)._updateID || 0;

		if (!forceLocation)
		{
			// TODO - maybe look into adding boundIds.. save us the loop?
			for (let i = 0; i < this.boundTextures.length; i++)
			{
				if (this.boundTextures[i] === texture)
				{
					if (!glTexture || texture.source && glTexture._sourceID !== _updateID)
					{
						location = i;
						break;
					}
					return i;
				}
			}

			if (location === undefined)
			{
				this._nextTextureLocation++;
				this._nextTextureLocation %= this.boundTextures.length;
				location = this.boundTextures.length - this._nextTextureLocation - 1;
			}
		}
		else
		{
			location = location || 0;
		}

		if (!glTexture || texture.source && glTexture._sourceID !== _updateID)
		{
			// this will also bind the texture..
			this.textureManager.updateTexture(texture, location);
		}
		else
		{
			// bind the current texture
			this.boundTextures[location] = texture;
			gl.activeTexture(gl.TEXTURE0 + location);
			gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
		}

		return location;
	}
});
